import React from 'react'
import { SwitchToggle } from '@softura/fluentuipackage';
import './switchtoggle.scss';

interface IProps {
  label?: string,
  defaultChecked?: boolean,
  onChange?: any,
  onText?: string,
  offText?: string,
  className?: string,
  checked?:boolean,
  title?:any
}

const SwitchToggleContainer = ({
  label,
  defaultChecked,
  onText,
  offText,
  onChange,
  className,
  checked,
  title
}:IProps) => {
  return (
    <SwitchToggle
      label = {label}
      defaultChecked = {defaultChecked}
      onChange = {onChange}
      onText = {onText}
      offText = {offText}
      className = {className}
      checked={checked}
      title={title}
    />
  )
}

export default SwitchToggleContainer
